import { render, staticRenderFns } from "./SearchEngineOptimisation.vue?vue&type=template&id=cb8072bc&"
import script from "./SearchEngineOptimisation.vue?vue&type=script&lang=js&"
export * from "./SearchEngineOptimisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports